module.exports = __webpack_public_path__ + "static/img/87024B_1_C_20210408_LC.c8b4b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87024B_1_C_20210408_LC.png
// module id = N+vj
// module chunks = 0